export const FRAMEWORK_ID = 'K2FrontendsFramework';
export const SESSION_STORAGE_KEYS = {
    USER_NAME: 'fw-user-name',
};
export const AUTH_TYPES = {
    EXTERNAL: 'external',
    FABRIC: 'FABRIC'
};
export const COOKIES_KEYS = {
    AUTH_TYPE: 'authType',
};
export const MAX_TIMEOUT_DELAY = 2147483647;